module.exports = __webpack_public_path__ + "static/media/DINPro-Regular_13937.86fda987.ttf";